<template>
  <router-view />
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "./styles/_global.css";
import "./styles/modern-table.css";
import "./styles/action-buttons.css";

export default {
  name: "app"
};
</script>
